import React from 'react';
import '../../less/mobile';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import palette from 'guideline';
import MenuItem from '../../views/menuItem.c';
import MainHeaderMenu from "./components/MainHeaderMenu";
import MenuCards from "./components/MenuCards";
import MenuDeposits from "./components/MenuDeposits";
import MenuCredits from "./components/MenuCredits";
import MenuServices from "./components/MenuServices";
import MenuBusiness from "./components/MenuBusiness";
import abankLogo from "../../img/new/abank-logo.svg"

export default function template() {
    const { isOpened } = this.state;

    let Component = null;
    switch (this.state.headerMenu) {
        case 'cards':
            Component = MenuCards;
            break;
        case 'deposits':
            Component = MenuDeposits;
            break;
        case 'credits':
            Component = MenuCredits;
            break;
        case 'services':
            Component = MenuServices;
            break;
        case 'business':
            Component = MenuBusiness;
            break;
        case 'main':
            Component = MainHeaderMenu;
            break;
        default:
            Component = MainHeaderMenu;
    }

    let menu = null;

    if (isOpened) {
        menu = (
            <CSSTransition
                classNames="module-header-mobile__menu"
                timeout={palette.transitionDurationNumber}
            >
                <Component {...this.props} toggle={this.toggle} changeMenu={this.changeMenu} toggleHover={this.toggleSubMenuItemHover} rentier_rate={this.props.rentier_rate} toggleMenu={this.toggle}/>
            </CSSTransition>
        );
    }

    return (
        <React.Fragment>
            <TransitionGroup component={null}>{menu}</TransitionGroup>
            <div className="module-header-mobile">
              <div className="mobile-header-top">
                <div className="container">
                  <div className="mobile-header-top__left left-mobile-header-top">
                      <a href="/" onClick={this.home} className="left-mobile-header-top__logo">
                        <img src={abankLogo} alt="abank-logo" />
                      </a>
                  </div>
                  <div className={`icon-menu__wrapper ${isOpened ? 'active' : ''}`} onClick={this.toggle}>
                    <div className={`icon-menu ${isOpened ? 'active' : ''}`}>
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </React.Fragment>
    );
}
